import KingColor from "images/achievements/100king-color.svg?url";
import KingGray from "images/achievements/100king-gray.svg?url";
import TutoringGray from "images/achievements/80-doucko-gray.svg?url";
import TutoringColor from "images/achievements/80-doucko.svg?url";
import SampionGray from "images/achievements/80-sampion-tydne-gray.svg?url";
import SampionColor from "images/achievements/80-sampion-tydne.svg?url";
import Session1Gray from "images/achievements/80-sessions-1-gray.svg?url";
import Session1Color from "images/achievements/80-sessions-1.svg?url";
import Session100Gray from "images/achievements/80-sessions-100-gray.svg?url";
import Session100Color from "images/achievements/80-sessions-100.svg?url";
import Session12Gray from "images/achievements/80-sessions-12-gray.svg?url";
import Session12Color from "images/achievements/80-sessions-12.svg?url";
import Session125Gray from "images/achievements/80-sessions-125 v3-gray.svg?url";
import Session125Color from "images/achievements/80-sessions-125 v3.svg?url";
import Session20Gray from "images/achievements/80-sessions-20-gray.svg?url";
import Session20Color from "images/achievements/80-sessions-20.svg?url";
import Session3Gray from "images/achievements/80-sessions-3-gray.svg?url";
import Session3Color from "images/achievements/80-sessions-3.svg?url";
import Session30Gray from "images/achievements/80-sessions-30-gray.svg?url";
import Session30Color from "images/achievements/80-sessions-30.svg?url";
import Session40Gray from "images/achievements/80-sessions-40-gray.svg?url";
import Session40Color from "images/achievements/80-sessions-40.svg?url";
import Session50Gray from "images/achievements/80-sessions-50-gray.svg?url";
import Session50Color from "images/achievements/80-sessions-50.svg?url";
import Session7Gray from "images/achievements/80-sessions-7-gray.svg?url";
import Session7Color from "images/achievements/80-sessions-7.svg?url";
import Session70Gray from "images/achievements/80-sessions-70-gray.svg?url";
import Session70Color from "images/achievements/80-sessions-70.svg?url";
import Session90Gray from "images/achievements/80-sessions-90-gray.svg?url";
import Session90Color from "images/achievements/80-sessions-90.svg?url";
import SuperstarGray from "images/achievements/80-superstart-gray.svg?url";
import SuperstarColor from "images/achievements/80-superstart.svg?url";

export interface IBadgeConfiguration {
  category: "plan" | "practice";
  id: string;
  type: string;
  title: string;
  iconGained: string;
  iconGray: string;
  count: number | null;
  modalTextEarned: string;
  modalTextNotEarned: string;
  // AIDEV-NOTE: Varianty pro studenty, kteří doučování nemají (maturanti) — text bez odkazu
  // na `/doucovani`, ze kterého by je guard vrátil na nástěnku. Vybírá se v Badges.tsx podle
  // `useContentAccess()`; konfigurace je čistá data, hook do ní nepatří. Vyplněné jsou jen
  // u odznaků, které na doučování odkazují. [TD-351]
  modalTextEarnedWithoutTutoring?: string;
  modalTextNotEarnedWithoutTutoring?: string;
}

export const badgesConfiguration: IBadgeConfiguration[] = [
  {
    category: "plan",
    id: "sessions-onboarding",
    type: "one-time",
    title: "Super start",
    iconGained: SuperstarColor,
    iconGray: SuperstarGray,
    count: null,
    modalTextEarned: "Vítej na palubě! Úvod máš za sebou a teď směle do procvičování. :-)",
    modalTextNotEarned: "",
  },
  {
    category: "plan",
    id: "plan",
    type: "aggregate",
    title: "Šampion týdne",
    iconGained: SampionColor,
    iconGray: SampionGray,
    count: 0,
    modalTextEarned:
      "Jsi šampion! Týdenní plán máš splněný a nám nezbývá než smeknout. Jen tak dál! Získáš odznak i v příštím týdnu?",
    modalTextNotEarned:
      "Ještě trocha cviku a odznak máš na triku! Šampion týdne budeš, až dokončíš poslední trénink z plánu pro tento týden",
  },
  {
    category: "plan",
    id: "tutorings",
    type: "aggregate",
    title: "Mistr doučování",
    iconGained: TutoringColor,
    iconGray: TutoringGray,
    count: 0,
    modalTextEarned:
      "Za každé dokončené doučovací téma jeden odznak Mistra doučování v kapse. Získáš všechny? <a href='/doucovani'>Přejít do doučování.</a>",
    modalTextNotEarned:
      "Za každé dokončené doučovací téma jeden odznak Mistra doučování v kapse. Získáš všechny? <a href='/doucovani'>Přejít do doučování.</a>",
    modalTextEarnedWithoutTutoring:
      "Za každé dokončené doučovací téma jeden odznak Mistra doučování v kapse. Získáš všechny?",
    modalTextNotEarnedWithoutTutoring:
      "Za každé dokončené doučovací téma jeden odznak Mistra doučování v kapse. Získáš všechny?",
  },
  {
    category: "practice",
    id: "sessions-1",
    type: "one-time",
    title: "Dokončen 1 trénink",
    iconGained: Session1Color,
    iconGray: Session1Gray,
    count: null,
    modalTextEarned: "Super! První trénink máš za sebou. Odznak za něj ti už nikdo neodpáře, je jen a jen tvůj.",
    modalTextNotEarned: "Odznak za první trénink na tebe čeká! Tak jdeme na to?",
  },
  {
    category: "practice",
    id: "sessions-3",
    type: "one-time",
    title: "Dokončeny 3 tréninky",
    iconGained: Session3Color,
    iconGray: Session3Gray,
    count: null,
    modalTextEarned: "Do třetice všeho dobrého! Máš za sebou tři úspěšné tréninky. Super, jen tak dál.",
    modalTextNotEarned: "Tenhle odznak může být tvůj za 3, 2, 1… Stačí, když 3× dokončíš trénink.",
  },
  {
    category: "practice",
    id: "sessions-7",
    type: "one-time",
    title: "Dokončeno 7 tréninků",
    iconGained: Session7Color,
    iconGray: Session7Gray,
    count: null,
    modalTextEarned: "Z tvého pokroku jsme v sedmém nebi! Gratulujeme k dokončení sedmého tréninku. Jsi skoro profík!",
    modalTextNotEarned:
      "Za sedmero horami, sedmero řekami a hlavně za sedmero tréninky čeká odznak. Pusť se do procvičování a brzy bude tvůj.",
  },
  {
    category: "practice",
    id: "sessions-12",
    type: "one-time",
    title: "Dokončeno 12 tréninků",
    iconGained: Session12Color,
    iconGray: Session12Gray,
    count: null,
    modalTextEarned: "Dobrá práce! Už máš tucet tréninků za sebou. Jde ti to skvěle, jen tak dál.",
    modalTextNotEarned: "Za dvanáctý trénink získáš tenhle odznak. Tak co, pustíme se rovnou do toho?",
  },
  {
    category: "practice",
    id: "sessions-20",
    type: "one-time",
    title: "Dokončeno 20 tréninků",
    iconGained: Session20Color,
    iconGray: Session20Gray,
    count: null,
    modalTextEarned: "No pane jo, dvacet tréninků v řadě, to už je něco! Máme radost, jak ti to jde.",
    modalTextNotEarned: "Dej si dvacet a tenhle odznak máš v kapse. Stačí dokončit dvě desítky tréninků.",
  },
  {
    category: "practice",
    id: "sessions-30",
    type: "one-time",
    title: "Dokončeno 30 tréninků",
    iconGained: Session30Color,
    iconGray: Session30Gray,
    count: null,
    modalTextEarned: "Máš za sebou třicátý trénink, paráda! Takhle vypadá poctivá příprava na přijímačky.",
    modalTextNotEarned: "Vedeš si skvěle! Co takhle ještě trochu potrénovat? Odznak za 30 tréninků už tu na tebe čeká.",
  },
  {
    category: "practice",
    id: "sessions-40",
    type: "one-time",
    title: "Dokončeno 40 tréninků",
    iconGained: Session40Color,
    iconGray: Session40Gray,
    count: null,
    modalTextEarned: "Tomu říkáme parádní pokrok! Už máš za sebou 40 tréninků. Jde ti to skvěle!",
    modalTextNotEarned: "Za 40 tréninků získáš tenhle odznak. Tak s vervou do toho a za chvilku máš hotovo!",
  },
  {
    category: "practice",
    id: "sessions-50",
    type: "one-time",
    title: "Dokončeno 50 tréninků",
    iconGained: Session50Color,
    iconGray: Session50Gray,
    count: null,
    modalTextEarned:
      "Gratulujeme k bezva výkonu! Už máš za sebou 50 tréninků. Máme takové tušení, že u přijímaček pěkně zaválíš.",
    modalTextNotEarned: "Vytáhneš to na 50 tréninků? Stačí ještě trocha procvičování a tenhle odznak bude tvůj.",
  },
  {
    category: "practice",
    id: "sessions-70",
    type: "one-time",
    title: "Dokončeno 70 tréninků",
    iconGained: Session70Color,
    iconGray: Session70Gray,
    count: null,
    modalTextEarned:
      "Wow, ty seš úplný trénink master! Už jich máš za sebou 70 a my doufáme, že to není ještě finální číslo.",
    modalTextNotEarned: "Ještě trocha procvičování a odznak za 70 tréninků bude tvůj. Tak co, jdeme rovnou na to?",
  },
  {
    category: "practice",
    id: "sessions-90",
    type: "one-time",
    title: "Dokončeno 90 tréninků",
    iconGained: Session90Color,
    iconGray: Session90Gray,
    count: null,
    modalTextEarned:
      "Gratulujeme! Získáváš odznak za 90 tréninků a naše obří uznání za to, jak poctivě se přípravě věnuješ. Takhle by to mělo vypadat!",
    modalTextNotEarned: "Ještě kousek a odznak za 90 tréninků bude tvůj. Pustíme se rovnou do procvičování?",
  },
  {
    category: "practice",
    id: "sessions-100",
    type: "one-time",
    title: "Dokončeno 100 tréninků",
    iconGained: Session100Color,
    iconGray: Session100Gray,
    count: null,
    modalTextEarned:
      "Juhůůů, tak to je jízda! Málokdo to dokáže vytáhnout z 0 na 100. Gratulujeme ke stovce dokončených tréninků.",
    modalTextNotEarned: "Zakulatíme společně počet tréninků? Za 100 dokončených získáš tenhle odznak.",
  },
  {
    category: "practice",
    id: "sessions-125",
    type: "one-time",
    title: "Dokončeno 125 tréninků",
    iconGained: Session125Color,
    iconGray: Session125Gray,
    count: null,
    modalTextEarned:
      "Jsi mistr tréninků! Na tuhle úroveň se dopracuje málokdo. Odznak za 125 dokončených tréninků má v naší aplikaci jen minimum studujících a ty jsi teď jedním z nich.",
    modalTextNotEarned:
      "Ještě trocha procvičování a získáš náš odznak za největší počet tréninků. Zařadíš se mezi elitu? Stačí dokončit 125 tréninků.",
  },
  {
    category: "plan",
    id: "perfect_session",
    type: "aggregate",
    title: "Trénink bez chyby",
    iconGained: KingColor,
    iconGray: KingGray,
    count: 0,
    modalTextEarned: "",
    modalTextNotEarned: "",
  },
];
